import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import CommonReducer from "./reducer";
const Common = combineReducers({
  common: CommonReducer,
  form: formReducer,
});

export default Common;
